import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { HTTP } from '../api/http-common';
import { Tabs, TabsList, TabsTrigger } from '@radix-ui/react-tabs';
import Swal from 'sweetalert2';
import { Trash } from 'lucide-react';
import { SearchIcon } from "lucide-react";

const VendorEdit = () => {
    const { id } = useParams();
    const memberId = Number(id);

    const navigate = useNavigate();
    const access_token = (localStorage.getItem('access_token'));

    const [selectedTab, setSelectedTab] = useState("profile");
    const [isEditable, setIsEditable] = useState(true);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const [searchValue, setSearchValue] = useState('');
    const [filterType, setFilterType] = useState("all");

    const [formData, setFormData] = useState({
        id: memberId,
        first_name: '',
        email: '',
        plan_amount: '',
        plan_type: '',
        plan_start_date: '',
        plan_expiration_date: '',
        business_name: '',
        business_category_id: '',
        contact_no: '',

        checkoutSessionId: '',
        transaction_id: '',
        status: '',
        type: '',
        message: '',
        created_at: '',
        updated_at: '',
        transaction_history: [],
    });

    const [addressformData, setAddressFormData] = useState(
        [{
            id: 0,
            address: "",
            city_id: "",
            state: "",
            postal_code: "",
            longitude: "",
            latitude: "",
            is_mon_open: true,
            mon_open_time: "",
            mon_close_time: "",
            is_tue_open: true,
            tue_open_time: "",
            tue_close_time: "",
            is_wed_open: true,
            wed_open_time: "",
            wed_close_time: "",
            is_thu_open: true,
            thu_open_time: "",
            thu_close_time: "",
            is_fri_open: true,
            fri_open_time: "",
            fri_close_time: "",
            is_sat_open: true,
            sat_open_time: "",
            sat_close_time: "",
            is_sun_open: false,
            sun_open_time: "",
            sun_close_time: "",
        }]
    );
    const [categoryList, setCategoryList] = useState([]);
    const [cityList, setcityList] = useState([]);

    const fetchAddressDetails = async () => {
        let config = {
            headers: { 'Content-Type': 'application/json', 'token': access_token },
        };

        try {
            const response = await HTTP.get(`/vendors_address/${memberId}`, config);

            if (response.status === 200) {
                const addressesMain = response.data.contents || [];

                if (addressesMain.length > 0) {
                    setAddressFormData(
                        addressesMain.map((address) => ({
                            id: address.id,
                            address: address.address || "",
                            city_id: address.city_id || "",
                            state: address.state || "",
                            postal_code: address.postal_code || "",
                            longitude: address.longitude || "",
                            latitude: address.latitude || "",
                            is_mon_open: address.is_mon_open || false,
                            mon_open_time: address.mon_open_time || "",
                            mon_close_time: address.mon_close_time || "",
                            is_tue_open: address.is_tue_open || false,
                            tue_open_time: address.tue_open_time || "",
                            tue_close_time: address.tue_close_time || "",
                            is_wed_open: address.is_wed_open || false,
                            wed_open_time: address.wed_open_time || "",
                            wed_close_time: address.wed_close_time || "",
                            is_thu_open: address.is_thu_open || false,
                            thu_open_time: address.thu_open_time || "",
                            thu_close_time: address.thu_close_time || "",
                            is_fri_open: address.is_fri_open || false,
                            fri_open_time: address.fri_open_time || "",
                            fri_close_time: address.fri_close_time || "",
                            is_sat_open: address.is_sat_open || false,
                            sat_open_time: address.sat_open_time || "",
                            sat_close_time: address.sat_close_time || "",
                            is_sun_open: address.is_sun_open || false,
                            sun_open_time: address.sun_open_time || "",
                            sun_close_time: address.sun_close_time || "",
                        }))
                    );
                }
            }
        } catch (error) {
            console.log("error", error);
        }
    };
    const fetchVendorDetails = async (planType = "all", searchTerm = "") => {
        let config = {
            headers: { 'Content-Type': 'application/json', 'token': access_token },
        };
        // Construct query params
        let queryParams = new URLSearchParams();
        if (planType && planType !== "all") { // Only add if filtering
            queryParams.append("plan_type", planType);
        }
        if (searchTerm) {
            queryParams.append("search", searchTerm); // Add search parameter
        }
        try {
            const response = await HTTP.get(`vendors/${memberId}?${queryParams.toString()}`, config);
            if (response.status === 200) {
                const data = response.data;

                if (data) {
                    const latestTransaction = data.transaction_history?.length > 0
                        ? data.transaction_history[data.transaction_history.length - 1]
                        : {};

                    setFormData({
                        id: memberId,
                        checkoutSessionId: data.checkoutSessionId,
                        transaction_id: data.transaction_id,
                        status: data.status,
                        type: data.type,
                        message: data.message,
                        created_at: data.created_at,
                        updated_at: data.updated_at,

                        first_name: data.first_name || '',
                        email: data.email || '',
                        business_name: data.business_name || '',
                        business_category_id: data.business_category_id || '',
                        contact_no: data.contact_no || '',
                        transaction_history: data.transaction_history || [], // Store full history
                        plan_type: data.plan_type || '',
                        plan_amount: data.plan_amount || '',
                        plan_start_date: data.created_at ? latestTransaction.created_at.slice(0, 10) : '',
                        plan_expiration_date: data.plan_expiration_date || '',
                    });
                }
            }
        } catch (error) {
            console.log("Error fetching vendor details:", error);
        }
    };

    // Handle filter change
    const handleFilterChange = (e) => {
        const newFilter = e.target.value;
        setFilterType(newFilter);
        fetchVendorDetails(newFilter); // Fetch with new filter
    };

    // Handle search enter
    const onSearchEnter = (value) => {
        setSearchValue(value);
        fetchVendorDetails(filterType, value); // Keep current filter while searching
    };

    const handleEditToggle = () => {
        setIsEditable(prevState => !prevState);
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const fetchCities = async () => {
        try {
            const access_token = localStorage.getItem('access_token');
            const config = {
                headers: { "Content-Type": "application/json", token: access_token },
            };

            const response = await HTTP.post("vendors_address/city", config);

            if (response.status === 200) {
                setcityList(response.data);
            }
        } catch (error) {
            console.error("Error fetching cities:", error);
        }
    };

    const fetchCategories = async () => {
        try {
            const access_token = localStorage.getItem('access_token');
            const config = {
                headers: { "Content-Type": "application/json", token: access_token },
            };

            let fields = {
                filters: {
                    search_value: "",
                },
                pagination: {
                    page: 1,
                    limit: 100
                },
                sorting: { field: 'id', type: 'desc' },
            };

            const response = await HTTP.post("/business_cate/list/all", fields, config);

            if (response.status === 200) {
                setCategoryList(response.data.contents);
            }
        } catch (error) {
            console.error("Error fetching categories:", error);
        }
    };

    const handleAddressChange = (e, index) => {
        const { name, value, type, checked } = e.target;
    
        setAddressFormData((prevData) => {
            const updatedData = [...prevData];
            updatedData[index] = {
                ...updatedData[index],
                [name]: type === "checkbox" ? checked : value,
            };
            return updatedData;
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const userId = memberId;
        setIsLoading(true);
        setError(null);

        try {
            const response = await HTTP.put(`/vendors/admin_update/${userId}`, formData, {
                headers: {
                    "Content-Type": "application/json",
                    token: access_token,
                },
            });

            if (response.status === 200) {
                Swal.fire({
                    icon: 'success',
                    title: 'Success!',
                    text: "Member Updated Succesfully",
                });
                navigate('/vendors');
            }
        } catch (error) {
            console.error("Error updating user:", error);
            setError("Failed to update user. Please try again.");
        } finally {
            setIsLoading(false);
        }
    };

    const handleAddressSubmit = async (e, index) => {
        e.preventDefault();

        const userId = memberId;
        if (!userId) {
            setError("Invalid user ID.");
            return;
        }

        if (!access_token) {
            setError("Unauthorized request. Please log in again.");
            return;
        }

        setIsLoading(true);
        setError(null);

        // Extract the specific address data for the submission
        const addressDataToSubmit = addressformData[index]; // Get data for this specific address

        try {
            const response = await HTTP.put(`/vendors_address/admin_update/${userId}`, addressDataToSubmit, {
                headers: {
                    "Content-Type": "application/json",
                    token: access_token,
                },
            });

            if (response.status === 200) {
                Swal.fire({
                    icon: "success",
                    title: "Success!",
                    text: "Vendor Address Updated Successfully",
                });

                if (typeof navigate === "function") {
                    setSelectedTab('address');
                    navigate(`/vendors/${memberId}`);
                }
            }
        } catch (error) {
            console.error("Error updating user:", error);

            const errorMessage = error.response?.data?.message || "Failed to update user. Please try again.";
            setError(errorMessage);

            Swal.fire({
                icon: "error",
                title: "Error!",
                text: errorMessage,
            });
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        if (selectedTab === 'profile') {
            fetchVendorDetails();
            fetchCategories();
        } else if (selectedTab === 'address') {
            fetchAddressDetails();
            fetchCities();
        } else if (selectedTab === 'transaction') {
            fetchVendorDetails();
        }
        console.log(addressformData)
    }, [selectedTab]);

    // useEffect(() => {
    // }, []);
    return (
        <>
            <div className="container mx-auto p-2 md:p-8 ">
                <div className="bg-white rounded-lg p-6 pb-0 border-gray-200 border min-h-40 flex flex-col justify-between">
                    <div className="flex items-center justify-between mb-8">
                        <div className="flex items-center gap-4">
                            <div className="w-12 h-12 rounded-full bg-purple-100 flex items-center justify-center">
                                <span className="text-purple-600 text-xl font-semibold">
                                    {/* {formData.first_name.charAt(0)} */}
                                </span>
                            </div>
                            <div>
                                <h3 className="font-semibold text-lg">{formData.first_name}</h3>
                                <p className="text-gray-600 text-sm">{formData.email}</p>
                            </div>
                        </div>
                    </div>

                    <Tabs defaultValue={selectedTab} className="TabsRoot">
                        <TabsList className="TabsList justify-start gap-6">
                            <TabsTrigger
                                value="profile"
                                className={`text-left justify-start w-0 p-0 TabsTrigger h-[60px] font-medium ${selectedTab === "profile" ? "data-[state=active]" : ""
                                    }`}
                                onClick={() => setSelectedTab?.("profile")}
                            >
                                Personal Information
                            </TabsTrigger>
                            <TabsTrigger
                                value="address"
                                className={`text-left justify-start w-0 p-0 TabsTrigger h-[60px] font-medium ${selectedTab === "address" ? "data-[state=active]" : ""
                                    }`}
                                onClick={() => setSelectedTab?.("address")}
                            >
                                Address Information
                            </TabsTrigger>
                            <TabsTrigger
                                value="transaction-history"
                                className={`text-left justify-start w-0 p-0 TabsTrigger h-[60px] font-medium ${selectedTab === "transaction" ? "data-[state=active]" : ""
                                    }`}
                                onClick={() => setSelectedTab?.("transaction")}
                            >
                                Plan History
                            </TabsTrigger>
                        </TabsList>
                        {formData.plan_amount && (
                            <div className="active-plan-container">
                                <p>
                                    <strong>Last Purchased Plan - </strong>
                                    {formData.plan_type === "month" ? (
                                        <>
                                            Monthly: ${formData.plan_amount} - Expiry Date: {formData.plan_expiration_date}
                                        </>
                                    ) : (
                                        <>
                                            Annual: ${formData.plan_amount} - Expiry Date: {formData.plan_expiration_date}
                                        </>
                                    )}
                                </p>
                            </div>
                        )}
                    </Tabs>
                    {selectedTab === 'profile' &&
                        <form className="space-y-4 mt-8" onSubmit={handleSubmit} >
                            {/* <div className="flex justify-end">
                                <button
                                    type='button'
                                    onClick={handleEditToggle}
                                    className="theme-button text-white px-4 py-2 rounded-md border-gray-200 border"
                                >
                                    {isEditable ? "Disable Edit" : "Enable Edit"}
                                </button>
                            </div> */}

                            <div className="bg-white rounded-lg p-6 border-gray-200 border">
                                <h3 className="font-medium text-lg mb-4">Info</h3>
                                <div className="grid grid-cols-2 gap-4">

                                    <div className="space-y-2">
                                        <label htmlFor="first_name" className="text-sm font-medium text-gray-500">
                                            First Name
                                        </label>
                                        <input
                                            type="text"
                                            id="first_name"
                                            name="first_name"
                                            className={`peer w-full focus:outline-none focus:border-b focus:border-gray-400 placeholder:text-gray-400 peer h-10 px-0 bg-transparent border-0 border-b input-border-bottom rounded-none focus-visible:ring-0 focus-visible:border-gray-400 ${!isEditable ? 'text-gray-500 bg-gray-100 cursor-not-allowed' : ''}`}
                                            value={formData.first_name}
                                            onChange={handleChange}
                                            disabled={!isEditable}
                                        />
                                    </div>

                                    <div className="space-y-2">
                                        <label htmlFor="email" className="text-sm font-medium text-gray-500">
                                            Email
                                        </label>
                                        <input
                                            type="email"
                                            id="email"
                                            name="email"
                                            className={`peer w-full focus:outline-none focus:border-b focus:border-gray-400 placeholder:text-gray-400 peer h-10 px-0 bg-transparent border-0 border-b input-border-bottom rounded-none focus-visible:ring-0 focus-visible:border-gray-400 ${!isEditable ? 'text-gray-500 bg-gray-100 cursor-not-allowed' : ''}`}
                                            value={formData.email}
                                            onChange={handleChange}
                                            disabled={!isEditable}
                                        />
                                    </div>

                                    <div className="space-y-2">
                                        <label htmlFor="business_name" className="text-sm font-medium text-gray-500">
                                            Business Name
                                        </label>
                                        <input
                                            type="text"
                                            id="business_name"
                                            name="business_name"
                                            className={`peer w-full focus:outline-none focus:border-b focus:border-gray-400 placeholder:text-gray-400 peer h-10 px-0 bg-transparent border-0 border-b input-border-bottom rounded-none focus-visible:ring-0 focus-visible:border-gray-400 ${!isEditable ? 'text-gray-500 bg-gray-100 cursor-not-allowed' : ''}`}
                                            value={formData.business_name}
                                            onChange={handleChange}
                                            disabled={!isEditable}
                                        />
                                    </div>
                                    <div className="space-y-2">
                                        <label htmlFor={`category`} className="text-sm font-medium">
                                            Category Name
                                        </label>
                                        <select
                                            name="business_category_id"
                                            value={formData.business_category_id}
                                            onChange={(e) => handleChange(e)}
                                            className="peer w-full focus:outline-none focus:border-b focus:border-gray-400 placeholder:text-gray-400 peer h-10 px-0 bg-transparent border-0 border-b input-border-bottom rounded-none focus-visible:ring-0 focus-visible:border-gray-400"
                                            disabled={!isEditable}
                                        >
                                            <option value="">Select Category</option>
                                            {Array.isArray(categoryList) && categoryList.length > 0
                                                ? categoryList.map((category) => (
                                                    <option key={category.id} value={category.id}>
                                                        {category.name}
                                                    </option>
                                                ))
                                                : <option value="">No Catogories available</option>}
                                        </select>
                                    </div>

                                    <div className="space-y-2">
                                        <label htmlFor="contact_no" className="text-sm font-medium text-gray-500">
                                            Contact Number
                                        </label>
                                        <input
                                            type="text"
                                            id="contact_no"
                                            name="contact_no"
                                            className={`peer w-full focus:outline-none focus:border-b focus:border-gray-400 placeholder:text-gray-400 peer h-10 px-0 bg-transparent border-0 border-b input-border-bottom rounded-none focus-visible:ring-0 focus-visible:border-gray-400 ${!isEditable ? 'text-gray-500 bg-gray-100 cursor-not-allowed' : ''}`}
                                            value={formData.contact_no}
                                            onChange={handleChange}
                                            disabled={!isEditable}
                                        />
                                    </div>
                                </div>
                            </div>

                            <button
                                type="submit"
                                className="theme-button text-white px-4 py-2 rounded-md border-gray-200 border"
                                disabled={!isEditable}
                                style={{
                                    backgroundColor: isEditable ? "#6c1cff" : "#ccc",
                                    cursor: isEditable ? "pointer" : "not-allowed",
                                    opacity: isEditable ? 1 : 0.6,
                                    marginBottom: "20px",
                                }}
                            >
                                Submit
                            </button>
                        </form>
                    }
                    {selectedTab === 'address' &&
                        addressformData.map((formData, index) => (
                            <form key={formData.id || index} className="space-y-4 mt-8" onSubmit={(e) => handleAddressSubmit(e, index)}>
                                <div className="bg-white rounded-lg p-6 border-gray-200 border">
                                    <div className="flex items-center justify-between">
                                        <h3 className="font-medium text-lg mb-4">
                                            Address {index + 1}
                                        </h3>
                                        {/* {formData.id ? (
                                            <span onClick={() => handleDelete(formData.id)}>
                                                <Trash className='w-4 h-4' />
                                            </span>
                                        ) : null} */}
                                    </div>

                                    <div className="grid grid-cols-2 gap-4">
                                        {/* Address */}
                                        <div className="space-y-2">
                                            <label htmlFor={`address-${index}`} className="text-sm font-medium">
                                                Address
                                            </label>
                                            <input
                                                type="text"
                                                id={`address-${index}`}
                                                name="address"
                                                className="peer w-full focus:outline-none focus:border-b focus:border-gray-400 placeholder:text-gray-400 peer h-10 px-0 bg-transparent border-0 border-b input-border-bottom rounded-none focus-visible:ring-0 focus-visible:border-gray-400"
                                                value={formData.address}
                                                onChange={(e) => handleAddressChange(e, index)}
                                            />
                                        </div>

                                        {/* City */}
                                        <div className="space-y-2">
                                            <label htmlFor={`city-${index}`} className="text-sm font-medium">
                                                City
                                            </label>
                                            <select
                                                name="city_id"
                                                value={formData.city_id}
                                                onChange={(e) => handleAddressChange(e, index)}
                                                className="peer w-full focus:outline-none focus:border-b focus:border-gray-400 placeholder:text-gray-400 peer h-10 px-0 bg-transparent border-0 border-b input-border-bottom rounded-none focus-visible:ring-0 focus-visible:border-gray-400"
                                            >
                                                <option value="">Select City</option>
                                                {Array.isArray(cityList) && cityList.length > 0
                                                    ? cityList.map((city) => (
                                                        <option key={city.id} value={city.id}>
                                                            {city.name}
                                                        </option>
                                                    ))
                                                    : <option value="">No cities available</option>}
                                            </select>
                                        </div>

                                        {/* State */}
                                        <div className="space-y-2">
                                            <label htmlFor={`state-${index}`} className="text-sm font-medium">
                                                State
                                            </label>
                                            <input
                                                type="text"
                                                id={`state-${index}`}
                                                name="state"
                                                className="peer w-full focus:outline-none focus:border-b focus:border-gray-400 placeholder:text-gray-400 peer h-10 px-0 bg-transparent border-0 border-b input-border-bottom rounded-none focus-visible:ring-0 focus-visible:border-gray-400"
                                                value={formData.state}
                                                onChange={(e) => handleAddressChange(e, index)}
                                            />
                                        </div>

                                        {/* Postal Code */}
                                        <div className="space-y-2">
                                            <label htmlFor={`postal_code-${index}`} className="text-sm font-medium">
                                                Postal Code
                                            </label>
                                            <input
                                                type="text"
                                                id={`postal_code-${index}`}
                                                name="postal_code"
                                                className="peer w-full focus:outline-none focus:border-b focus:border-gray-400 placeholder:text-gray-400 peer h-10 px-0 bg-transparent border-0 border-b input-border-bottom rounded-none focus-visible:ring-0 focus-visible:border-gray-400"
                                                value={formData.postal_code}
                                                onChange={(e) => handleAddressChange(e, index)}
                                            />
                                        </div>

                                        <div className="space-y-2">
                                            <label htmlFor={`latitude-${index}`} className="text-sm font-medium">
                                                Latitude
                                            </label>
                                            <input
                                                type="text"
                                                id={`latitude-${index}`}
                                                name="latitude"
                                                className="peer w-full focus:outline-none focus:border-b focus:border-gray-400 placeholder:text-gray-400 peer h-10 px-0 bg-transparent border-0 border-b input-border-bottom rounded-none focus-visible:ring-0 focus-visible:border-gray-400"
                                                value={formData.latitude}
                                                onChange={(e) => handleAddressChange(e, index)}
                                            />
                                        </div>

                                        <div className="space-y-2">
                                            <label htmlFor={`longitude-${index}`} className="text-sm font-medium">
                                                Longitude
                                            </label>
                                            <input
                                                type="text"
                                                id={`longitude-${index}`}
                                                name="longitude"
                                                className="peer w-full focus:outline-none focus:border-b focus:border-gray-400 placeholder:text-gray-400 peer h-10 px-0 bg-transparent border-0 border-b input-border-bottom rounded-none focus-visible:ring-0 focus-visible:border-gray-400"
                                                value={formData.longitude}
                                                onChange={(e) => handleAddressChange(e, index)}
                                            />
                                        </div>

                                        {["mon", "tue", "wed", "thu", "fri", "sat", "sun"].map((day) => (
                                            <div className="col-span-2 grid grid-cols-3 gap-4 items-center" key={day}>
                                                <div className="space-y-2">
                                                    <label className="admin-table-toggle-switch">
                                                        <input
                                                            type="checkbox"
                                                            name={`is_${day}_open`}
                                                            checked={formData[`is_${day}_open`]}
                                                            onChange={(e) => handleAddressChange(e, index)}
                                                            className="admin-table-toggle-input"
                                                        />
                                                        <span
                                                            className={`admin-table-slider ${formData[`is_${day}_open`] ? "admin-table-slider-checked" : ""}`}
                                                        >
                                                            <span
                                                                className={`admin-table-slider-before ${formData[`is_${day}_open`] ? "admin-table-slider-checked-before" : ""}`}
                                                            ></span>
                                                        </span>
                                                    </label>
                                                    <label className="text-sm font-medium">&nbsp;&nbsp;{day.charAt(0).toUpperCase() + day.slice(1)}</label>
                                                </div>
                                                <div className="space-y-2">
                                                    <label className="text-sm font-medium">Open Time</label>
                                                    <input
                                                        type="time"
                                                        name={`${day}_open_time`}
                                                        value={formData[`${day}_open_time`]}
                                                        onChange={(e) => handleAddressChange(e, index)}
                                                        className="input"
                                                        disabled={!formData[`is_${day}_open`]}
                                                    />
                                                </div>
                                                <div className="space-y-2">
                                                    <label className="text-sm font-medium">Close Time</label>
                                                    <input
                                                        type="time"
                                                        name={`${day}_close_time`}
                                                        value={formData[`${day}_close_time`]}
                                                        onChange={(e) => handleAddressChange(e, index)}
                                                        className="input"
                                                        disabled={!formData[`is_${day}_open`]}
                                                    />
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                    <button
                                        type="submit"
                                        className="theme-button text-white px-4 py-2 rounded-md border-gray-200 border"
                                    >
                                        Submit
                                    </button>
                                </div>
                            </form>
                        ))
                    }
                    {selectedTab === 'transaction' &&
                        <div className="bg-white">
                            {/* <div className="bg-white rounded-lg p-6 border-gray-200 border"> */}
                            <h3 className="font-bold text-xl mb-5">Plan History</h3>
                            <div className="flex justify-between items-center">
                                <div className="w-1/2 flex">
                                    <div className="w-1/2 border-b border-gray-300 mr-6">
                                        <div className="flex items-center">
                                            <span className="w-4">
                                                <SearchIcon className="w-4" />
                                            </span>
                                            <input
                                                type="text"
                                                placeholder="Search Plan"
                                                className="admin-table-search-input w-full"
                                                value={searchValue}
                                                onChange={(e) => setSearchValue(e.target.value)}
                                                onKeyDown={(e) => { if (e.key === 'Enter') { onSearchEnter(e.target.value) } }}
                                            />
                                        </div>
                                    </div>
                                    <div className="w-1/2 border-b border-gray-300">
                                        <select
                                            className="admin-table-filter-dropdown w-full"
                                            value={filterType}
                                            onChange={handleFilterChange}
                                        >
                                            <option value="all">All Types</option>
                                            <option value="month">Monthly</option>
                                            <option value="annual">Annually</option>
                                        </select>
                                    </div>
                                </div>

                            </div>
                            {Array.isArray(formData.transaction_history) && formData.transaction_history.length > 0 ? (
                                <table className="admin-table-table mt-5">
                                    <thead>
                                        <tr>
                                            <th className="admin-table-th">Plan Amount</th>
                                            <th className="admin-table-th">Plan Type</th>
                                            <th className="admin-table-th">Checkout Session Id</th>
                                            <th className="admin-table-th">Transaction ID</th>
                                            <th className="admin-table-th">Type</th>
                                            <th className="admin-table-th">Message</th>
                                            <th className="admin-table-th">Status</th>
                                            <th className="admin-table-th">Created At</th>
                                            <th className="admin-table-th">Updated At</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {formData.transaction_history.map((transaction) => (
                                            <tr key={transaction.id}>
                                                <td className="admin-table-th-td">{transaction.plan_amount}</td>
                                                <td className="admin-table-th-td">{transaction.plan_type}</td>
                                                <td className="admin-table-th-td">{transaction.checkoutSessionId}</td>
                                                <td className="admin-table-th-td">{transaction.transaction_id}</td>
                                                <td className="admin-table-th-td">{transaction.type}</td>
                                                <td className="admin-table-th-td">{transaction.message}</td>
                                                <td className="admin-table-th-td">{transaction.status === "1" ? "Active" : "Inactive"}</td>
                                                <td className="admin-table-th-td">{new Date(transaction.created_at).toLocaleDateString()}</td>
                                                <td className="admin-table-th-td">{new Date(transaction.updated_at).toLocaleDateString()}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            ) : (
                                <p className="text-gray-500 mt-4">No plan history available.</p>
                            )}

                        </div>
                    }
                </div>
            </div>
        </>
        // <>This is Edit Vendor</>
    )
}

export default VendorEdit